import { Component, OnInit, Input } from '@angular/core';
import { CleanerService } from "../../../../injections/cleaner.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'cleaner-availability',
    templateUrl: '../../templates/partials/availability-cleaner.html'
})

export class AvailabilityCleanerComponent implements OnInit {
    @Input() availability: Array<object>;
    @Input() blocked = 0;
    public hours = [
        "8:00-9:00","9:00-10:00","10:00-11:00","11:00-12:00","12:00-13:00","13:00-14:00","14:00-15:00",
        "15:00-16:00","16:00-17:00","17:00-18:00","18:00-19:00", "19:00-20:00","20:00-21:00","21:00-22:00"
    ];
    private availabilityCopy: Array<object> = [];
    public editAvailability:boolean = false;
    public idCleaner;

    constructor(private cleanerService: CleanerService, private _route: ActivatedRoute, private router: Router) {
        this._route.params
        .subscribe(params => {
            this.idCleaner = params["id"];
        });
     }

    public seeAvailability(){
        //console.log(this.availability);
    }
    public changeAvailability(event,day){
        if(this.editAvailability){
            day.available = (day.available == 0) ? 1 : 0;
            if(day["changed"] != true){
                day["changed"] = true;
            }else{
                day["changed"] = false;
            }
        }
    }

    public changeColumnAvailability(day) {
        day = parseInt(day);
        if(this.editAvailability){
            this.availability.forEach((element, i) => {
                element["days"].forEach((hour, j) => {
                    var value;
                    if(hour["day"] == day){
                        if(hour["columnSelected"] == 1){
                            value = 0;
                            hour["columnSelected"] = 0;
                        }else{
                            value = 1;
                            hour["columnSelected"] = 1;
                        }
                        hour["available"] = value;
                    }   
                    
                })
            })
        }
    }



    public toggleEditAvailability(){

         this.availabilityCopy = JSON.parse(JSON.stringify(this.availability));
         this.editAvailability = (this.editAvailability) ? false : true;
    }

    public cancelEditAvailability(){
         this.editAvailability = false;
         this.availability = this.availabilityCopy;
    }

    public saveAvailability(){
        
        var a_object = this.parseAvailability(this.availability);
        var data = {
            availabilities: a_object
        }
        this.cleanerService.updateCleanerAvailability(this.idCleaner, data).subscribe(status => {
                if(status == "OK"){
                    this.editAvailability = false;
                }
        });
    }

    private parseAvailability(a: Array<object>) {
        var availability_parsed: Array<object> = [];
        for(var j = 0; j < a.length; j++){
            for(var i = 0; i < a[j]["days"].length; i++){
                availability_parsed.push(a[j]["days"][i]);
            }
        }

        return availability_parsed;
    }

    ngOnChanges(changes: any) {}


    public isDisabled(){
        return this.editAvailability;
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/availability-cleaner.component.ts